import { lazy, Suspense, useEffect } from 'react';
/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import {  Route, Switch, withRouter } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import './vendor/datatables/css/dataTables.min.css';
import "./css/style.css";

const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => import('./jsx/pages/Login'));
//Website Login
const Home = lazy(() => import('./jsx/website/Home'));
const About = lazy(() => import('./jsx/website/About'));
const Visualize = lazy(() => import('./jsx/website/Visualize'));
const Aspirstion = lazy(() => import('./jsx/website/Aspirstion'));
const Focus = lazy(() => import('./jsx/website/Focus'));
const Trade = lazy(() => import('./jsx/website/Trade'));
const Achievement = lazy(() => import('./jsx/website/Achievement'));
const Diversity = lazy(() => import('./jsx/website/Diversity'));
const Vision = lazy(() => import('./jsx/website/Vision'));
const News = lazy(() => import('./jsx/website/News'));
const Liverate = lazy(() => import('./jsx/website/Liverate'));
const Gold = lazy(() => import('./jsx/website/Gold'));
const Silver = lazy(() => import('./jsx/website/Silver'));
const Investor = lazy(() => import('./jsx/website/Investor'));
const Faq = lazy(() => import('./jsx/website/Faq'));
const Onlinetrading = lazy(() => import('./jsx/website/Onlinetrading'));
const Booking = lazy(() => import('./jsx/website/Booking'));
const Kyc = lazy(() => import('./jsx/website/Kyc'));
const Contact = lazy(() => import('./jsx/website/Contact'));
// const Login = lazy(() => {
//     return new Promise(resolve => {
//     setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
//   });
// });

function App (props) {
    const dispatch = useDispatch();
    useEffect(() => {
        checkAutoLogin(dispatch, props.history);
    }, [dispatch, props.history]);
    
    let routes = (  
        <Switch>
            <Route exact path='/' component={Home} />
            <Route exact path='/about' component={About} />
            <Route exact path='/visualize' component={Visualize} />
            <Route exact path='/aspirstion' component={Aspirstion} />
            <Route exact path='/focus' component={Focus} />
            <Route exact path='/trade' component={Trade} />
            <Route exact path='/achievement' component={Achievement} />
            <Route exact path='/diversity' component={Diversity} />
            <Route exact path='/vision' component={Vision} />
            <Route exact path='/news' component={News} />
            <Route exact path='/liverate' component={Liverate} />
            <Route exact path='/gold' component={Gold} />
            <Route exact path='/silver' component={Silver} />
            <Route exact path='/investor' component={Investor} />
            <Route exact path='/faq' component={Faq} />
            <Route exact path='/onlinetrade' component={Onlinetrading} />
            <Route exact path='/booking' component={Booking} />
            <Route exact path='/kyc' component={Kyc} />
            <Route exact path='/contact' component={Contact} />
            <Route exact path='/login' component={Login} />
            <Route exact path='/page-register' component={SignUp} />
            <Route exact path='/page-forgot-password' component={ForgotPassword} />
        </Switch>
    );
    if (props.isAuthenticated) {
		return (
			<>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>  
                   }
                >
                    <Index / >
                </Suspense>
            </>
        );
	
	}else{
		return (
			<div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                  }
                >
                    {routes}
                </Suspense>
			</div>
		);
	}
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App)); 

